import React from "react";
import { useIntl } from "react-intl";
import { IconBed, IconHome, IconParkingCircleFilled, IconRuler, IconUsers } from "@tabler/icons-react";
import { classNames } from "@ct-react/core";
import { ResumeFeaturesData } from "../../models/article";
import "./resume-features.scss";

type ResumeFeaturesProps = ResumeFeaturesData & { className?: string };

const ResumeFeatures = (props: ResumeFeaturesProps) => {

  const intl = useIntl();
  const wrapperClasses = classNames("r-resume-features", props.className);

  if (Object.keys(props).length === 0)
    return <></>;

  return (
    <ul className={wrapperClasses}>
      {!!props.rooms &&
        <li>
          <IconHome />
          <span>
            {intl.formatMessage({
              id: "card-features-rooms",
              defaultMessage: "{rooms, plural, =1 {# pièce} other {# pièces}}"
            }, props)}
          </span>
        </li>
      }
      {!!props.maxGuests &&
        <li>
          <IconUsers />
          <span>
            {intl.formatMessage({
              id: "card-features-guests",
              defaultMessage: "{maxGuests, plural, =1 {# invité} other {# invités}}"
            }, props)}
          </span>
        </li>
      }
      {!!props.bedrooms &&
        <li>
          <IconBed />
          <span>
            {intl.formatMessage({
              id: "card-features-bedrooms",
              defaultMessage: "{bedrooms, plural, =1 {# chambre} other {# chambres}}"
            }, props)}
          </span>
        </li>
      }
      {!!props.livingSpace &&
        <li>
          <IconRuler />
          <span>{props.livingSpace} m²</span>
        </li>
      }
      {(!!props.parkings && props.parkings > 0) &&
        <li>
          <IconParkingCircleFilled />
          <span>
            {intl.formatMessage({
              id: "card-features-parkings",
              defaultMessage:"{parkings, plural, =1 {# place} other {# places}}"
            }, props)}
          </span>
        </li>
      }
    </ul>
  );
}

export default ResumeFeatures;
